import script from "./ShakyoTaikenDetailNittei.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoTaikenDetailNittei.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoTaikenDetailNittei.vue?vue&type=style&index=0&id=326c8742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-326c8742"]])

export default __exports__